// ForgeProvider Component
// This file defines a provider to wrap Forge UI components and apply Forge styles globally.

import { ReactNode } from "react";
import "@Forge/dist/forge.css";
import { Root } from "@/vendor/Forge/dist";

/**
 * Props for the ForgeProvider component
 * @param children - React children to be rendered inside the provider
 */
interface Props {
  children?: ReactNode;
}

/**
 * ForgeProvider Component
 * Wraps children in the Forge Root and applies the required Forge CSS class for styling.
 * Ensures all Forge components receive the correct styles.
 *
 * @param children - React children to be rendered inside the provider
 */
const ForgeProvider = ({ children }: Props) => (
  // Forge requires this classname for styles to be applied.
  <Root>
    <div className="fe_f_all">{children}</div>
  </Root>
);

export default ForgeProvider;
